export const seperationTypes = [
  "Voluntary",
  "Involuntary",
  "Death",
  "Retirement",
];
export const voluntaryReasons = [
  "Better Career & Monetary Opportunities",
  "Organization Culture",
  "Location / Commute Constraint",
  "Higher Studies",
  "Starting Own Business",
  "Health / Family / Personal Reasons / City Change",
  "Internal Movement - Apprentice to Full-Time Conversion",
  "Retirement",
  "Reason Not Disclosed",
];

export const involuntaryReasons = [
  "Performance Issue",
  "Code of Conduct / Disciplinary Issue",
  "Red BVC / Background Verification",
  "No Role / Workforce Restructuring",
  "End of Contract",
  "Demise",
  "Permanent Disability",
  "Job Abandonment / Absconding / Prolonged Absence",
  "Productivity Enhancement",
];

export const seperationTaskList = [
  {
    employee_id: "423568",
    full_name: "Ankita Shinde ",
    request_type: "Separation Approval",
    date_of_resignation: "05 February 2024",
    req_date_of_exit: "29 February 2024",
    reason: "Better Opportunities",
    status: "Pending",
    task_action: "edit",
  },
  {
    employee_id: "423568",
    full_name: "John Doe ",
    request_type: "IT clearance",
    date_of_resignation: "05 February 2024",
    req_date_of_exit: "29 February 2024",
    reason: "Better Opportunities",
    status: "Pending",
    task_action: "Approve",
  },
  {
    employee_id: "423568",
    full_name: "John Doe ",
    request_type: "Finance Clearance",
    date_of_resignation: "05 February 2024",
    req_date_of_exit: "29 February 2024",
    reason: "Better Opportunities",
    status: "Pending",
    task_action: "edit",
  },
  {
    employee_id: "423568",
    full_name: "John Doe ",
    request_type: "Admin Clearance",
    date_of_resignation: "05 February 2024",
    req_date_of_exit: "29 February 2024",
    reason: "Better Opportunities",
    status: "Pending",
    task_action: "Approve",
  },
  {
    employee_id: "423568",
    full_name: "John Doe ",
    request_type: "Payroll Clearance",
    date_of_resignation: "05 February 2024",
    req_date_of_exit: "29 February 2024",
    reason: "Better Opportunities",
    status: "Pending",
    task_action: "Approve",
  },
];
